module.exports = __webpack_public_path__ + "static/media/Item_Weapon_NagantM1895_C.bf5e0a4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Handgun/Item_Weapon_NagantM1895_C.png
// module id = 205
// module chunks = 0